<template>
  <div class="container-fluid">
    <div
      v-for="(attribute, index) in errors"
      :key="index"
      class="alert alert-danger"
    >
      <div v-for="error in attribute" v-bind:key="error">
        {{ error }}
      </div>
    </div>
    <h4 class="m-3">Изменение акции</h4>
    <el-form ref="form" :model="form" label-width="120px" id="uploadForm" name="uploadForm"
             enctype="multipart/form-data">
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Подзаголовок">
        <el-input type="textarea" v-model="form.subtitle"></el-input>
      </el-form-item>
      <el-form-item label="Описание">
        <el-input type="textarea" v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item label="Плашка">
        <div class="action-form__label">
          <p class="action-label__name">Фоновый цвет</p>
          <el-color-picker v-model="form.label.color" size="large" />
          <p class="action-label__name">Текст</p>
          <el-input v-model="form.label.title"></el-input>
          <p class="action-label__name">Краткий текст</p>
          <el-input v-model="form.label.short_title"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Приоритет">
        <el-input v-model="form.priority"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Изображение">
        <input type="file" id="files" ref="files" accept=".gif,.png,.jpeg" v-on:change="handleFilesUpload()" class="mb-3"/>
        <div class="row" v-for="(file, index) in files" :key="file.lastModified">
          <div class="col-md-5 mb-3">
            <img v-bind:ref="'image'+parseInt( index )" style="height: 100px"/>
            <a @click="deleteFile(index)" class="el-icon-close"></a>
          </div>
        </div>
        <div class="row mb-3" v-if="flag">
          <div class="col-md-5">
            <img class="mb-3" style="height: 100px" :src="form.img.path">
            <a @click="deleteImg()" class="el-icon-close"></a>
          </div>
        </div>
      </el-form-item>
      <el-row>
        <el-col :span="+4">
          <el-form-item label="Действует с">
            <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy/MM/dd" placeholder="Select date"
                            v-model="form.from_date">

            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="+4">
          <el-form-item label="по">
            <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy/MM/dd" placeholder="Select date"
                            v-model="form.to_date">

            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <hr>
      <el-form-item>
        <h6>Тип акции</h6>
        <el-tabs v-model="form.type" @tab-click="notMounted" type="border-card">
          <el-tab-pane label="Товар в подарок" name="product_gift">
            <el-form-item label-width="50%"
                          label="Товары, которые необходимо купить вместе, чтобы получить товар в подарок">
              <el-button type="primary" @click="$store.commit('showProductsDialog',true)">Выбрать товары</el-button>
              <p>Выбрано: {{ form.products.length }}</p>
            </el-form-item>
            <el-form-item label-width="50%" label="Товары/товар в подарок">
              <el-button type="primary" @click="$store.commit('showProductsGiftDialog',true)">Выбрать подарки
              </el-button>
              <p>Выбрано: {{ form['gift_products'].length }}</p>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Скидка на товары" name="discount_on_products">
            <el-form-item label="Товары">
              <el-button type="primary" @click="$store.commit('showProductsDialog',true)">Выбрать товары</el-button>
                <p>Выбрано: {{ form.products.length }}</p>
            </el-form-item>
            <el-form-item label="Скидка (%)">
              <el-input v-model="form.discount" placeholder="0" type="number"></el-input>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Скидка на категорию" name="discount_on_section">
            <el-form-item label-width="50%" label="Разделы каталога">
                <el-button size="small" type="primary" @click="toggleDialog()">Выбрать</el-button>
                <el-tag v-if="selectedSections.length">
                  Выбрано: {{ selectedSections.length }}
                </el-tag>
            </el-form-item>
            <el-form-item label-width="50%" label="Скидка (%)">
              <el-input placeholder="0" v-model="form.discount" type="number"></el-input>
            </el-form-item>
              <CatalogSectionDialog
                v-if="form.type === 'discount_on_section' && $store.getters.showCatalogSectionDialog"
                :items-payload="selectedSections"
                :returns-ids="true"
                @saveItems="onSaveItems"
              />
          </el-tab-pane>
          <el-tab-pane label="Скидка на товары определенного производителя" name="discount_on_maker">
            <el-form-item label="Производитель">
              <el-select v-model="form.maker_id" filterable clearable>
                <el-option
                    v-for="item in makers"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Скидка (%)">
              <el-input placeholder="0" v-model="form.discount" type="number"></el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <hr>
      <el-form-item label="Тэги">
        <el-row>
          <el-col :span="+4">
            <el-select
              v-model="form.tags"
              clearable
              multiple
              placeholder="Выберите тег"
              class="container-article__select"
            >
              <el-option
                v-for="item in tags"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="+2">
            <el-button type="primary" @click="$store.commit('promoActionTagCreateDialog',true)">Добавить тэг</el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="updatePromoaction()">Изменить</el-button>
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
    <create-promo-action-tag-dialog
      @updateParent="Update"
    ></create-promo-action-tag-dialog>
    <select-products
      :selectedProducts="form.products"
      @select-product="selectProduct"
      v-if="$store.getters.showProductsDialog"
    ></select-products>
    <select-products-gifts
      :selectedProducts="form.products"
      :selectedGifts="form['gift_products']"
      @select-product="selectGift"
      v-if="$store.getters.showProductsGiftDialog"
    ></select-products-gifts>
  </div>
</template>

<script>
import axios from "axios";
import SelectProducts from "@/components/Products/SelectProducts";
import SelectProductsGifts from "@/components/Products/SelectProductsGifts";
import CreatePromoActionTagDialog from "@/components/PromoActions/PromoActionTagCreateDialog";
import { SETPRELOADER_STATE } from '../../store/mutation-types.js';
import useAction from '../../composable/useAction.js';
import useFormData from '../../composable/useFormData.js';
import deepClone from '../../composable/utils/deepClone.js';
import CatalogSectionDialog from '../CatalogSectionDialog';

export default {
  components: {
    SelectProductsGifts, 
    SelectProducts, 
    CreatePromoActionTagDialog,
    CatalogSectionDialog
  },
  data: function () {
    return {
      form: {
        title: "",
        description: "",
        from_date: "",
        to_date: "",
        type: "product_gift",
        discount: 0,
        subtitle: "",
        sort: 1,
        activity: true,
        priority: 1,
        products: [],
        maker_id: '',
        catalog_section_id: '',
        'gift_products': [],
        tags: [],
        img: {
          path: "",
          alt: ""
        },
        label: {
          color: "",
          short_title: "",
          title: "",
        },
      },
      selectedSections: [],
      flag: true,
      files: [],
      products: [],
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      categories: [],
      tags: [],
      status: 0,
      makers: [],
      actionTypes: [],
      sectionsId: null,
      selectedProductCounter: null,
      selectedProductGiftCounter: null,
      errors: [],
    }
  },
  mounted() {
    this.form = this.$store.getters.currentAction?.id ? this.$store.getters.currentAction : this.form
    this.form.products = this.$store.getters.currentActionProducts.length ? this.$store.getters.currentActionProducts : [] 
    this.form['gift_products'] = this.$store.getters.currentActionGifts.length ? this.$store.getters.currentActionGifts : [] 
    this.tags = this.$store.getters.actionTags.length ? this.$store.getters.actionTags : []
    this.makers = this.$store.getters.actionMakers.length ? this.$store.getters.actionMakers : []

    this.form.tags = [...this.form.tags.map((item) => item.id)]

    this.cachedForm = deepClone(this.form)

    if (!this.promoAction?.id || !this.tags.length || !this.makers.length) {
      this.fetchActionData()
    } else if (this.promoAction.id) {
      this.promoAction.tags = [...this.promoAction.tags.map((item) => item.id)]
    }

    const action = useAction.bind(this)
    const { actionTypes } = action()

    this.actionTypes = actionTypes
  },
  methods: {
    fetchActionData() {
      this.$store.commit(SETPRELOADER_STATE, true)

      Promise.all([
        this.getPromoAction(), 
        this.getTags(), 
        this.getMakers(), 
        this.getProducts(), 
        this.getProductsGifts()
      ]).then((response) => {
        const [promoAction, tags, makers, products, productsGifts] = response

        this.form = promoAction.data
        this.tags = tags.data
        this.makers = makers.data
        this.form.products = products.data
        this.form['gift_products'] = productsGifts.data

        this.cachedForm = deepClone(this.form)
        this.selectedSections = this.form.catalog_section_id ? [this.form.catalog_section_id] : []

        this.form.tags = [...this.form.tags.map((el) => el.id)]
      }).finally(() => {
        this.$store.commit(SETPRELOADER_STATE, false)
      })
    },
    updateProducts(productIds) {
      this.promoAction.productsIds = productIds;
    },
    updateProductsGift(productIds) {
      this.promoAction.productsGiftIds = productIds;
    },
    getMakers() {
      return axios.get('/promo-action/maker')
    },
    getProducts() {
      const id = this.$route.params.id
      return axios.get(`promo-action/${id}/product`)
    },
    getProductsGifts() {
      const id = this.$route.params.id
      return axios.get(`promo-action/${id}/gift-product`)
    },
    notMounted(e) {
      const type = e.$options.propsData.name

      if (type !== this.cachedForm.type) {
        this.form.discount = '';
        this.form.catalog_section_id = '';
        this.form.maker_id = '';
        this.form['gift_products'].length = 0;
        this.form.products.length = 0
      } else {
        this.form.discount = this.cachedForm.discount;
        this.form.catalog_section_id = this.cachedForm.catalog_section_id;
        this.form['gift_products'] = [...this.cachedForm['gift_products']];
        this.form.products = [...this.cachedForm.products];
        this.form.maker_id = this.cachedForm.maker_id;
      }

      this.selectedSections = this.form.catalog_section_id ? [this.form.catalog_section_id] : []
    },
    back() {
      this.$router.go(-1);
    },
    getTags() {
      return axios.get('/promo-action/tag')
    },
    deleteFile(index) {
      this.files.splice(index, 1);
      this.getImagePreviews();
    },
    deleteImg: function () {
      this.flag = false;
    },
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {

        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {

          let reader = new FileReader();

          reader.addEventListener("load", function () {
            this.$refs['image' + parseInt(i)][0].src = reader.result;
          }.bind(this), false);
          reader.readAsDataURL(this.files[i]);
        }
      }
    },
    addFiles() {
      this.$refs.files.click();
    },
    handleFilesUpload() {
      this.flag = false;
      this.files = [];

      let uploadedFiles = this.$refs.files.files;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }

      this.getImagePreviews();
    },
    getPromoAction() {
      return axios.get(`/promo-action/${this.$route.params.id}`)
    },
    Update(newTag) {
      this.tags.push(newTag);
    },
    updatePromoaction() {
      this.form.products = [...this.form.products.map((item) => item.id)]
      this.form['gift_products'] = [...this.form['gift_products'].map((item) => item.id)]

      const data = useFormData().execute().setFields([
      'title',
      'description',
      'from_date',
      'to_date',
      'type',
      'subtitle',
      'sort',
      'activity',
      'priority',
      'label',
      'products',
      'gift_products',
      'tags',
      'img',
      'catalog_section_id',
      'maker_id'
    ]).getFormData(this.form)

    const currentTypes = this.actionTypes.find((el) => el.name === this.form.type)

    if (currentTypes) {
      currentTypes.append(data)
    }

    this.$store.commit(SETPRELOADER_STATE, true)

    axios.post(`/promo-action/${this.form.id}`, data).then((response) => {
        this.status = response.status;
        this.back();
      }).catch((errors) => {
        if (errors.response.status === 401) {
          this.$router.push('/login');
        }

        this.errors = errors.response.data.errors
      }).finally(() => {
        this.$store.commit(SETPRELOADER_STATE, false)
      });
    },
    selectProduct(productSelectCounter) {
      this.selectedProductCounter = productSelectCounter;
    },
    selectGift(giftSelectCounter) {
      this.selectedProductGiftCounter = giftSelectCounter;
    },

    toggleDialog() {
      this.$store.commit('showCatalogSectionDialog', !this.$store.getters.showCatalogSectionDialog);
    },
    setFormSection(){
      this.form.catalog_section_id = this.selectedSections[0] ?? ''
    },
    handleDeleteCat(index){
      this.selectedSections.splice(index, 1)
      this.setFormSection()
    },
    onSaveItems(items) {
      this.selectedSections = items
      this.setFormSection()
    }
  }
}
</script>

<style scoped>

</style>